<div class="dialog-header">
    <h2 mat-dialog-title>AI Setup Fund</h2>
    <button mat-icon-button mat-dialog-close class="dialog-close" aria-label="Close" data-test="dialog-close">
        <mat-icon>close</mat-icon>
    </button>
</div>

<mat-dialog-content class="ai-setup-dialog-content">
    <form [formGroup]="form">

        <section class="dialog-section">
            <h3>Assets in scope</h3>
            <div class="select-row">
                <button mat-stroked-button type="button" (click)="selectHeldOnly()">Held only</button>
                <button mat-stroked-button type="button" (click)="selectAll()">Select all</button>
                <button mat-stroked-button type="button" (click)="clearAll()">Clear</button>
                <span class="select-row-spacer"></span>
                <button mat-stroked-button color="primary" type="button" (click)="findAllMissing()">
                    <mat-icon>travel_explore</mat-icon>
                    Find all missing URLs
                </button>
            </div>
            <div class="asset-list">
                @for (asset of data.assets; track asset.id) {
                    <div class="asset-row-group">
                        <div class="asset-row">
                            <mat-checkbox class="asset-row-check"
                                [checked]="isAssetSelected(asset.id)"
                                (change)="toggleAsset(asset.id, $event.checked)">
                                {{ asset.name }}
                                @if (!asset.isHeld) {
                                    <span class="muted-tag">realized</span>
                                }
                            </mat-checkbox>
                            <mat-form-field appearance="outline" class="asset-row-url" subscriptSizing="dynamic">
                                <input matInput type="url" placeholder="https://…"
                                       [value]="getUrl(asset.id)"
                                       (input)="onUrlInput(asset.id, $any($event.target).value)"
                                       [disabled]="isSearching(asset.id)">
                            </mat-form-field>
                            <button mat-stroked-button type="button" class="asset-row-find"
                                    (click)="findUrl(asset)" [disabled]="isSearching(asset.id)">
                                @if (isSearching(asset.id)) { Searching… } @else { Find }
                            </button>
                        </div>
                        @let suggestions = getSuggestions(asset.id);
                        @if (suggestions.length > 0) {
                            <div class="url-suggestions">
                                <div class="url-suggestions-header">
                                    <span>Pick the right one:</span>
                                    <button mat-icon-button type="button" (click)="dismissSuggestions(asset.id)" aria-label="Dismiss">
                                        <mat-icon>close</mat-icon>
                                    </button>
                                </div>
                                @for (item of suggestions; track item.url) {
                                    <button mat-button type="button" class="url-suggestion"
                                            (click)="pickSuggestion(asset, item)">
                                        <div class="url-suggestion-title">{{ item.title }}</div>
                                        <div class="url-suggestion-url">{{ item.url }}</div>
                                    </button>
                                }
                            </div>
                        }
                    </div>
                }
            </div>
            <div class="hint">
                URLs you provide here are saved to the asset before AI Setup runs, so the prompts can use them.
                Leave blank to keep whatever URL is already on the asset.
            </div>
        </section>

        <section class="dialog-section">
            <h3>What to fill in</h3>
            <div class="section-list">
                @for (section of sections; track section.value) {
                    <mat-checkbox
                        [checked]="isSectionSelected(section.value)"
                        (change)="toggleSection(section.value, $event.checked)">
                        {{ section.label }}
                    </mat-checkbox>
                }
            </div>
        </section>

        <section class="dialog-section">
            <h3>Overwrite policy</h3>
            <mat-radio-group formControlName="overwriteMode" class="overwrite-modes">
                @for (mode of overwriteModes; track mode.value) {
                    <mat-radio-button [value]="mode.value">{{ mode.label }}</mat-radio-button>
                }
            </mat-radio-group>
        </section>

        <section class="dialog-section">
            <h3>Extra context for AI <span class="muted-tag">optional</span></h3>
            <mat-form-field appearance="outline" class="full-width">
                <textarea matInput rows="3" formControlName="contextNote"
                          placeholder="e.g. Acme lost their CFO last quarter, factor into SWOT"></textarea>
            </mat-form-field>
        </section>

        <div class="disclaimer">
            <mat-icon class="disclaimer-icon">warning</mat-icon>
            <span>AI-generated content must be reviewed and accepted before it is applied to your fund.
                You will be able to review each asset on the next screen.</span>
        </div>
    </form>
</mat-dialog-content>

<mat-dialog-actions align="end">
    <button mat-flat-button color="primary" type="button" (click)="submit()" [disabled]="form.invalid">Generate</button>
</mat-dialog-actions>
